import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Label from 'zignal-landscape/lib/Label';
import Field from 'zignal-landscape/lib/Field';
import List from 'zignal-landscape/lib/List';
import Select from 'zignal-landscape/lib/Select';

import DashboardTemplateItem from './DashboardTemplateItem';
import Styles from './DashboardSettingsModal.css';

const DEFAULT_DASHBOARDS = [];
const DEFAULT_TEMPLATE_TYPES = [];

const DashboardTemplateItems = ({
  typeLabel = '',
  dashboards = DEFAULT_DASHBOARDS,
  duplicateFrom,
  templateTypes = DEFAULT_TEMPLATE_TYPES,
  value,
  onChange,
  onChangeDuplicateFrom,
  typeLabelPlural = ''
}) => {
  const duplicateTemplateType = {
    label: 'Duplicate',
    description: `Choose a ${typeLabel} to copy`
  };

  // Select first template on mount
  useEffect(() => {
    onChange(templateTypes[0]);
  }, [templateTypes]);

  useEffect(() => {
    onChangeDuplicateFrom(dashboards?.[0]?.options?.[0]);
  }, [dashboards]);

  function handleTemplateTypeChange(selectedValue) {
    onChange(selectedValue);
  }

  function handleDuplicateFromChange(selectedValue) {
    onChangeDuplicateFrom(selectedValue);
  }

  function isTemplateTypeSelected(templateType) {
    return value && value.label === templateType.label;
  }

  return (
    <React.Fragment>
      <Field>
        <Label>Choose a {typeLabel} Template</Label>
        <List>
          {templateTypes.map((templateType, key) => (
            <DashboardTemplateItem
              onChange={handleTemplateTypeChange}
              checked={isTemplateTypeSelected(templateType)}
              key={key}
              templateType={templateType}
            />
          ))}
          <DashboardTemplateItem
            onChange={handleTemplateTypeChange}
            checked={isTemplateTypeSelected(duplicateTemplateType)}
            templateType={duplicateTemplateType}
          >
            <div className={Styles.itemSelectWrapper}>
              <Field>
                <Select
                  value={duplicateFrom}
                  menuPosition={'fixed'}
                  menuShouldBlockScroll
                  onChange={handleDuplicateFromChange}
                  options={dashboards}
                  selectStyles={{
                    singleValue: base => ({
                      ...base,
                      padding: 0,
                      lineHeight: 'inherit'
                    })
                  }}
                />
              </Field>
            </div>
          </DashboardTemplateItem>
        </List>
      </Field>
    </React.Fragment>
  );
};

DashboardTemplateItems.propTypes = {
  typeLabel: PropTypes.string,
  typeLabelPlural: PropTypes.string,
  dashboards: PropTypes.array,
  duplicateFrom: PropTypes.any,
  templateTypes: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onChangeDuplicateFrom: PropTypes.func
};

export default DashboardTemplateItems;
